/* eslint-disable no-param-reassign */
import { get } from 'lodash';
import * as MutationTypes from '@/store/mutation-types';
import OpportunitiesApi from '../../backend/api/Opportunities';
import WishesApi from '../../backend/api/Wishes';
import { fetchResource } from '../../utils';
import { assignHelper, fetchList } from '../helpers';

export default {
  namespaced: true,
  state: {
    show: null,
    list: [],
    wishAmount: null,
  },
  mutations: {
    [MutationTypes.SET_OPPORTUNITIES]: assignHelper('list'),
    [MutationTypes.SET_OPPORTUNITY_SHOW]: assignHelper('show'),
    [MutationTypes.STORE_WISH]: assignHelper('wishAmount'),
  },
  actions: {
    fetchList: fetchList(OpportunitiesApi, MutationTypes.SET_OPPORTUNITIES),
    sendWish({ state, dispatch }) {
      const amount = state.wishAmount.replace(/\s/g, '');
      const opportunityId = state.show.data.id;
      const promise = WishesApi.post(opportunityId, { amount }).then(() => {
        dispatch('fetch', { id: opportunityId, force: true });
      });
      return promise;
    },
    declineWish(_, { opportunityId, wishReason }) {
      return WishesApi.decline(opportunityId, wishReason);
    },
    fetch: fetchResource(OpportunitiesApi, MutationTypes.SET_OPPORTUNITY_SHOW),
  },
  getters: {
    canInvest: (state, getters) =>
      !getters.currentUserWish,
    canDecline: state =>
      !get(state.show, 'data.attributes.declinedAt'),
    canAccept: (state, getters) =>
      get(state.show, 'data.attributes.enteredAdministrativePhaseAt')
        && !get(getters.currentUserWish, 'attributes.acceptedAt'),
    currentUserWish: state =>
      get(state.show, 'data.attributes.currentUserWish'),
  },
};
